enum CheckoutPaths {
  Checkout = "/checkout",
  ThankYou = "/checkout/thank-you"
}

export default CheckoutPaths;
